import { TestCaseRepository } from '@/domain/repositories/testCase/TestCaseRepository'
import { TestCase } from '@/domain/value_objects/testCase/TestCase'

export class GetTestCaseListUseCase {
  constructor(private repository: TestCaseRepository) {}

  async getTestCaseList(problemId: string): Promise<TestCase[]> {
    try {
      const data = await this.repository.getTestCaseList(problemId)
      return data
    } catch (error) {
      console.error(`Error in GetTestCaseListUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
